import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget } from 'react-dnd'
import TreeItem from './TreeItem'

const findItem = (id, items) => {
  for (const node of items) {
    if (node.id == id) return node
    if (node.children && node.children.length) {
      const result = findItem(id, node.children)
      if (result) {
        return result
      }
    }
  }

  return false
}

const target = {
  drop() {},

  hover(props, monitor, component) {
    const {id: draggedId, nodeId, items} = monitor.getItem()

    if (!monitor.isOver({shallow: true})) return

    const descendantNode = findItem(props.nodeId, items)
    if (descendantNode) return
    if (nodeId == props.nodeId) return
    if (draggedId == props.nodeId) return

    props.move(draggedId, props.id, props.nodeId)
  }
}

@DropTarget(props => props.itemType, target, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget()
}))
export default class TreeSortContainer extends Component {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    itemType: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    nodeId: PropTypes.any,
    move: PropTypes.func.isRequired,
    drop: PropTypes.func,
    renderItem: PropTypes.func.isRequired
  };

  drop() {
    this.props.drop && this.props.drop()
  }

  render () {
    const {connectDropTarget, renderItem, items, nodeId, itemType, move, drop, ...props} = this.props

    return connectDropTarget(
      <div {...props}>
        {items.map((item, i) => {
          return (
            <TreeItem
              itemType={itemType}
              key={item.id || i}
              id={item.id || i}
              item={item}
              nodeId={nodeId}
              move={move.bind(this)}
              drop={this.drop.bind(this)}
            >
              {renderItem(item, i)}
            </TreeItem>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/TreeSortContainer.js